export default __webpack_public_path__ + "static/article-car-insurance-payout-cc714faf5325905d381ffb1e1e46fc46.jpg";